module.exports = __webpack_public_path__ + "static/img/mw.6073ddcf.svg";